/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {ReferenceDataModel} from '../../../api/reference-data.model';
import {UserBaseContract} from '../../api/contracts/user-base.contract';
import {DatepickerHelperService} from '../../../shared/utils/datepicker-helper/datepicker-helper.service';
import {ClosedOnCellValueModel} from '../models/closed-on-cell-value.model';
import {PrettyPrintClosedByPipe} from '../../shared/pipes/pretty-closed-by/pretty-print-closed-by.pipe';
import {BundleSentCellValueModel} from '../models/bundle-sent-cell-value.model';
import {PeriodBundlesTableStatusEnum} from '../models/period-bundles-table-status.enum';
import {SentOnCellValueModel} from '../models/sent-on-cell-value.model';

export function statusPipe(cellValue: ReferenceDataModel): string {
    let displayValue = '-';

    if (cellValue?.name != null) {
        displayValue = `${cellValue.name}`;
    }

    return displayValue;
}

export function percentagePipe(cellValue: number): string {
    let displayValue = '-';

    if (cellValue != null) {
        displayValue = `${cellValue.toFixed(2)}%`;
    }

    return displayValue;
}

export function userPipe(cellValue: UserBaseContract): string {
    let displayValue = '-';
    if (cellValue != null) {
        displayValue = (new PrettyPrintClosedByPipe())
                .transform(cellValue);
    }
    return displayValue;
}

export function closedOnPipe(cellValue: ClosedOnCellValueModel): string {
    let value = '-';
    if (cellValue?.closedOn != null && cellValue?.timeZone != null) {
        value = DatepickerHelperService.convertTimestampToDateAndTime(cellValue.closedOn, cellValue.timeZone);
    }
    return value;
}

export function sentOnPipe(cellValue: SentOnCellValueModel): string {
    let value = '-';
    if (cellValue?.date != null && cellValue?.timeZone != null) {
        value = DatepickerHelperService.convertTimestampToDateAndTime(cellValue.date, cellValue.timeZone);
    }
    return value;
}

export function sentUnsentPipe(cellValue: BundleSentCellValueModel): string {
    let displayValue = '-';
    if (cellValue?.closed === PeriodBundlesTableStatusEnum.CLOSED) {
        displayValue = cellValue.sent ? 'Sent' : 'Unsent';
    }
    return displayValue;
}
